import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import Header from "../sections/Header";
import Sidebar from "../sections/Sidebar";
import { encStorage } from "../hooks/encStorage";
import { GET_REFERRALS } from "../services/Apis";
import axios from "axios";

const Referrals = () => {
  const [financials, setFinancials] = useState({});
  const [SidebarState, setSidebarState] = useState(false);
  const [walletBalance, setWalletBalance] = useState(0);
  const [totCommissions, setTotCommissions] = useState(0);
  const [slabName, setslabName] = useState("");
  const [slabLevel, setslabLevel] = useState("");
  const [referrals, setReferrals] = useState([]);
  const [sortConfig, setSortConfig] = useState({ key: null, direction: "asc" });

  const updateSidebarState = (newState) => {
    setSidebarState(newState);
  };

  const fetchReferrals = async () => {
    const token = encStorage.getItem("token");
    try {
      const response = await axios.get(GET_REFERRALS, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      const data = response.data;
      setWalletBalance(data.walletbalance);
      setTotCommissions(data.totalCommission);
      setReferrals(data.records);
      setslabName(data.slab_name);
      setslabLevel(data.level);
      //console.log(data);
      //console.log(totCommissions);
    } catch (error) {
      console.error("Error fetching referrals:", error);
    }
  };

  useEffect(() => {
    fetchReferrals(); // Run on page load
    const interval = setInterval(fetchReferrals, 60000); // Run every 60 seconds
    return () => clearInterval(interval);
  }, []);

  const sortTable = (key) => {
    let direction = "asc";
    if (sortConfig.key === key && sortConfig.direction === "asc") {
      direction = "desc";
    }

    const sortedReferrals = [...referrals].sort((a, b) => {
      const aValue = a[key];
      const bValue = b[key];

      if (key === "openDate") {
        return direction === "asc"
          ? new Date(aValue) - new Date(bValue)
          : new Date(bValue) - new Date(aValue);
      } else if (key === "total") {
        const totalA = parseFloat(a.commissionEarned) + parseFloat(a.lastMonthSalary);
        const totalB = parseFloat(b.commissionEarned) + parseFloat(b.lastMonthSalary);
        return direction === "asc" ? totalA - totalB : totalB - totalA;
      } else if (!isNaN(parseFloat(aValue)) && !isNaN(parseFloat(bValue))) {
        return direction === "asc" ? parseFloat(aValue) - parseFloat(bValue) : parseFloat(bValue) - parseFloat(aValue);
      } else {
        return direction === "asc"
          ? aValue?.toString().localeCompare(bValue?.toString())
          : bValue?.toString().localeCompare(aValue?.toString());
      }
    });

    setReferrals(sortedReferrals);
    setSortConfig({ key, direction });
  };


  return (
    <>
      <Header updateState={updateSidebarState} />
      <div id="layoutSidenav">
        <Sidebar props={SidebarState} />
        <div id="layoutSidenav_content" className="layout-content">
          <div className="container mt-3">
            <div className="row justify-content-center">
              <div className="col-lg-10">
                <h2 className="mb-3 text-primary">Referrals</h2>
                <div className="mt-1 mb-4 w-100">
                  <div className="row g-3">
                    <div className="col-md-3">
                      <div className="card bg-brand-white shadow-sm border-0 text-center">
                        <div className="card-body">
                          <div className="d-flex justify-content-inbetween align-items-center">
                            <i className="fa-solid fa-users fa-2x text-primary w-25"></i>
                            <div className="text-end w-75">
                              <h5 className="fs-3 fw-bold">
                                {referrals.length}
                              </h5>
                              <h6 className="card-title fs-7">My Referrals</h6>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="col-md-3">
                      <div className="card bg-brand-white shadow-sm border-0 text-center">
                        <div className="card-body">
                          <div className="d-flex justify-content-inbetween align-items-center">
                            <i className="fa-solid fa-layer-group fa-2x text-success w-25"></i>
                            <div className="text-end w-75">
                              <h5 className="fs-3 fw-bold">
                                {slabName ?? "-"}
                              </h5>
                              <h6 className="card-title fs-7">
                                Current Level {slabLevel ?? "-"}
                              </h6>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="col-md-3">
                      <div className="card bg-brand-white shadow-sm border-0 text-center">
                        <div className="card-body">
                          <div className="d-flex justify-content-inbetween align-items-center">
                            <i className="fa-solid fa-coins fa-2x text-warning w-25"></i>
                            <div className="text-end w-75">
                              <h5 className="fs-3 fw-bold">{totCommissions}</h5>
                              <h6 className="card-title fs-7">
                                Month's Commission
                              </h6>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="col-md-3">
                      <div className="card bg-brand-white shadow-sm border-0 text-center">
                        <div className="card-body">
                          <div className="d-flex justify-content-inbetween align-items-center">
                            <i className="fa-solid fa-wallet fa-2x text-info w-25"></i>
                            <div className="text-end w-75">
                              <h5 className="fs-3 fw-bold">
                                {walletBalance >= 500 ? (
                                  <Link
                                    to="/redeem-commission"
                                    state={{ walletBalance }}
                                    className="btn btn-primary btn-sm fs-7 me-1 p-1 m-0"
                                  >
                                    Redeem {walletBalance}
                                  </Link>
                                ) : (
                                  walletBalance
                                )}
                              </h5>
                              <h6 className="card-title fs-7">
                                Wallet Balance
                              </h6>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="table-responsive">
                  <table className="table table-bordered table-striped w-100 align-middle">
                    <thead>
                      <tr>
                        <th onClick={() => sortTable("index")}>#</th>
                        <th onClick={() => sortTable("client_code")}>Acc. Id</th>
                        <th onClick={() => sortTable("name")}>Name</th>
                        <th onClick={() => sortTable("openDate")}>Joining Date</th>
                        <th onClick={() => sortTable("lastMonthSalary")}>Last Month Salary</th>
                        <th onClick={() => sortTable("totalCommission")}>Total Commission</th>
                        <th onClick={() => sortTable("commissionEarned")}>Commission Earned</th>
                        <th onClick={() => sortTable("total")}>Total</th>
                      </tr>
                    </thead>
                    <tbody>
                      {referrals.map((referral, index) => (
                        <tr key={index}>
                          <td>{index + 1}</td>
                          <td>{referral.client_code}</td>
                          <td>{referral.name}</td>
                          <td>{new Date(referral.openDate).toLocaleString()}</td>
                          <td className="text-end">{referral.lastMonthSalary}</td>
                          <td className="text-end">{referral.totalCommission}</td>
                          <td className="text-end">{referral.commissionEarned}</td>
                          <td className="text-end">
                            {(+referral.commissionEarned + +referral.lastMonthSalary).toFixed(2)}
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Referrals;
